import { useCallback, useContext, useRef } from 'react';
import { Button } from '@core/components/Button';
import { PROMPT_MODAL_CANCEL_BUTTON, PROMPT_MODAL_INPUT, PROMPT_MODAL_SAVE_BUTTON, } from '@core/components/testIds';
import { useContextTranslation } from '@core/i18n';
import { isMobileWeb } from '@core/userAgent';
import { ButtonClose } from './ButtonClose';
import { ModalContext } from './ModalContext';
import { ErrorWrapper, HintWrapper, Input, PromptForm, PromptWrapper, Title, } from './Prompt.styles';
/**
 *
 */
export const Prompt = ({ onSave, onCancel, onChange, saveLabel, placeholder, labelText, error = '', hint = '', saveEnabled = true, inputEnabled = true, saveVisible = true, inputVisible = true, defaultValue = '', maxValueLength = -1, }) => {
    const { t } = useContextTranslation();
    const { title } = useContext(ModalContext);
    const input = useRef(null);
    const onSubmit = useCallback((event) => {
        event.preventDefault();
        if (onSave) {
            onSave(input.current?.value);
        }
    }, [onSave]);
    return (<PromptWrapper>
      {onCancel && (<div style={{ position: 'absolute', top: '0', right: '0' }}>
          <ButtonClose data-testid={PROMPT_MODAL_CANCEL_BUTTON} onClick={onCancel}/>
        </div>)}
      <PromptForm onSubmit={onSubmit}>
        <Title>{title}</Title>

        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--spacing-2)',
            justifyContent: 'space-between',
            alignItems: 'stretch',
        }}>
          {Boolean(error) && <ErrorWrapper>{error}</ErrorWrapper>}
          {Boolean(hint) && <HintWrapper>{hint}</HintWrapper>}

          {inputVisible && (<Input type="text" maxLength={maxValueLength} placeholder={placeholder} disabled={!inputEnabled} onChange={onChange} autoComplete={isMobileWeb() ? 'off' : 'on'} defaultValue={defaultValue} ref={input} data-testid={PROMPT_MODAL_INPUT} aria-label={labelText}/>)}

          {saveVisible && (<Button data-testid={PROMPT_MODAL_SAVE_BUTTON} disabled={!saveEnabled} type="submit" variant="primary" style={{
                '--button-border-radius': 'var(--player-button-border-radius)',
            }}>
              {saveLabel ?? t('Save')}
            </Button>)}
        </div>
      </PromptForm>
    </PromptWrapper>);
};
